export const uk = {
    degree: '°C',
    from: 'от',
    to: 'до',
    'warning-one-more-item': 'Должно быть выбрано хотя бы одно значение'
};
